import React, { useState, useRef } from "react";
import { ModalContent, ModalWrapper } from "./styles";
import {
	Button,
	InputWithButton,
	Modal,
	Text,
	Link,
	InterestedContactForm,
	Icon,
} from "@website-builder/ui/shared/elements";
import { handleCTAClick } from "@website-builder/utilities/utils/DesignUtils.js";
import { addToDataLayer } from "@website-builder/utilities/utils/utils.js";
import { isBusinessVerticalB2U } from "@website-builder/utilities/utils/helpers.js";
import { BUTTON_INTERACTION } from "@website-builder/utilities/constants/click-events.js";
import { CONSENT_REQUIRED } from "@website-builder/utilities/constants/messages.js";
const isB2u = isBusinessVerticalB2U();

const RequestSyllabus = ({
	buttonText = "Request Syllabus",
	type = "secondary",
	requestFormType = "emailForm",
	primaryColorButton = false,
	context = {},
	pageSection = null,
	workshopId = "",
	onSuccess = () => {},
	btnClassName = null,
	modalConfiguration = [],
	cta,
	modalId = "",
}) => {
	const [showEmailForm, setShowEmailForm] = useState(false);
	const [showContactForm, setShowContactForm] = useState(false);
	const [isSuccess, setIsSuccess] = useState(false);

	const agreementCheckboxRef = useRef();
	const [agreementChecked, setAgreementChecked] = useState(false);
	const [agreementError, setAgreementError] = useState("");
	const [resetKey, setResetKey] = useState(false);

	const handleButtonClick = (formType) => {
		if (formType === "emailForm") {
			setShowEmailForm(true);
		} else if (formType === "contactForm") {
			setShowContactForm(true);
		}
		addToDataLayer({
			event: "request_syllabus_button_click",
			page_section: pageSection,
			request_form_type: requestFormType,
		});
	};

	const resetForm = () =>
		setTimeout(() => {
			setResetKey(!resetKey);
			setAgreementError("");
		}, 300);
	const handleSuccess = (phone_no) => {
		setIsSuccess(true);
		onSuccess?.();
	};
	const closeEmailForm = () => {
		setShowEmailForm(false);
		setIsSuccess(false);
		resetForm();
	};
	const closeContactForm = () => {
		setShowContactForm(false);
		resetForm();
	};

	const agreementCheck = () => {
		if (!agreementChecked) {
			setAgreementError(CONSENT_REQUIRED);
			return false;
		}
		setAgreementError("");
		return true;
	};
	const handleB2UClick = () => {
		if (!modalConfiguration.length) {
			handleButtonClick();
		}
		handleCTAClick(cta, {
			page_section: pageSection,
			click_text: cta?.buttonText,
			redirect_to: cta?.link?.link,
		});
	};

	return (
		<>
			{isB2u && (
				<Button
					modalConfiguration={modalConfiguration}
					buttonConfiguration={isB2u && cta}
					buttonText={buttonText}
					aria-expanded={showContactForm || showEmailForm}
					aria-controls={modalId}
					aria-haspopup="dialog"
					type={type}
					primaryColorButton={primaryColorButton}
					onClick={handleB2UClick}
					className={btnClassName}
				/>
			)}

			{!isB2u && requestFormType === "emailForm" && (
				<>
					<Button
						buttonConfiguration={isB2u && cta}
						buttonText={buttonText}
						type={type}
						aria-expanded={showEmailForm}
						aria-controls={modalId}
						aria-haspopup="dialog"
						primaryColorButton={primaryColorButton}
						onClick={() => handleButtonClick("emailForm")}
						className={btnClassName}
					/>
					<Modal
						show={showEmailForm}
						disableBackdropClick={true}
						onClose={closeEmailForm}
						key={resetKey}
						id={modalId}
					>
						<ModalContent>
							<div className="email">
								{!isSuccess ? (
									<>
										<Text variant="headline_5">
											Get the detailed syllabus delivered to your email.
										</Text>
										<InputWithButton
											inputType="email"
											placeholder="Enter your email"
											buttonText="Get Syllabus"
											buttonConfiguration={cta}
											buttonEvent={BUTTON_INTERACTION.SYLLABUS_DOWNLOAD}
											context={context}
											onSuccess={handleSuccess}
											workshopId={workshopId}
											pageSection={pageSection}
											agreementCheck={agreementCheck}
										/>
										<label
											className={`emailConfirmCheckbox ${
												agreementError ? "invalid" : null
											}`}
										>
											<input
												ref={agreementCheckboxRef}
												type="checkbox"
												onClick={() =>
													setAgreementChecked(
														agreementCheckboxRef?.current?.checked,
													)
												}
											/>
											<Text variant="paragraph_S" tag="span">
												By submitting this information, you agree to our{" "}
												<Link href="/legal/privacy/" target="_blank">
													Privacy Policy
												</Link>{" "}
												and grant us permission to contact you regarding our
												programs.
											</Text>
										</label>
										{agreementError ? (
											<Text variant="paragraph_S" className="errorMessage">
												{agreementError}
											</Text>
										) : null}
									</>
								) : (
									<div className="successMessageWrapper">
										<Icon iconName="checkCircle" size="32px" />
										<Text variant="paragraph_L" className="message">
											Awesome, we just sent the syllabus to your email.
										</Text>
									</div>
								)}
							</div>
						</ModalContent>
					</Modal>
				</>
			)}
			{!isB2u && requestFormType === "contactForm" && (
				<ModalWrapper>
					<Button
						buttonConfiguration={isB2u && cta}
						buttonText={buttonText}
						type={type}
						aria-expanded={showContactForm}
						aria-controls={modalId}
						aria-haspopup="dialog"
						onClick={() => handleButtonClick("contactForm")}
					/>
					<Modal
						show={showContactForm}
						disableBackdropClick={true}
						onClose={closeContactForm}
						key={resetKey}
						id={modalId}
						className="request-syllabus-modal-wrapper"
					>
						<InterestedContactForm
							callbackOnError={() => {}}
							successMessage={"Syllabus is sent to your email"}
							className={"request-syllabus-form"}
							onSuccess={(data) => handleSuccess(data.phone_no)}
							context={context}
						></InterestedContactForm>
					</Modal>
				</ModalWrapper>
			)}
		</>
	);
};

export default RequestSyllabus;
